
    import './styles.scoped.css';
    export default {
  "icon-shake": "awsui_icon-shake_1cbgc_pjowk_101",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_pjowk_1",
  "container-fade-in": "awsui_container-fade-in_1cbgc_pjowk_129",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_pjowk_1",
  "root": "awsui_root_1cbgc_pjowk_151",
  "status-error": "awsui_status-error_1cbgc_pjowk_160",
  "status-warning": "awsui_status-warning_1cbgc_pjowk_163",
  "status-success": "awsui_status-success_1cbgc_pjowk_166",
  "status-info": "awsui_status-info_1cbgc_pjowk_169",
  "status-stopped": "awsui_status-stopped_1cbgc_pjowk_172",
  "status-pending": "awsui_status-pending_1cbgc_pjowk_175",
  "status-in-progress": "awsui_status-in-progress_1cbgc_pjowk_178",
  "status-loading": "awsui_status-loading_1cbgc_pjowk_181",
  "color-override-red": "awsui_color-override-red_1cbgc_pjowk_184",
  "color-override-grey": "awsui_color-override-grey_1cbgc_pjowk_187",
  "color-override-blue": "awsui_color-override-blue_1cbgc_pjowk_190",
  "color-override-green": "awsui_color-override-green_1cbgc_pjowk_193",
  "color-override-yellow": "awsui_color-override-yellow_1cbgc_pjowk_196",
  "container": "awsui_container_1cbgc_pjowk_129",
  "display-inline": "awsui_display-inline_1cbgc_pjowk_200",
  "icon": "awsui_icon_1cbgc_pjowk_101",
  "display-inline-block": "awsui_display-inline-block_1cbgc_pjowk_208",
  "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_pjowk_217"
};
  